// 判断是否走微信快捷授权
import { commonHost, isInWechat } from 'utils';

// 判断是否走微信快捷授权
export function wechatQuickAuth() {
    let channel = '',
        needAuth = false;

    if (!isInWechat || typeof URLSearchParams === 'undefined') return { channel, needAuth };

    const searchParams = new URLSearchParams(window.location.search);
    const pathname = window.location.pathname;

    if (pathname === '/market/fast-renew/detail') {
        const role = searchParams.get('role');
        channel = role || '';

        if (['farming', 'cebei'].includes(channel)) {
            needAuth = true;
        }
    }

    if (pathname === '/market/fast-renew/distributor/detail') {
        const sem_channel = searchParams.get('sem_channel');
        channel = sem_channel || '';

        if (['RTK2'].includes(channel)) {
            needAuth = true;
        }
    }

    return { channel, needAuth };
}

export const gotoLogin = (() => {
    let isCalling = false;

    return ({ replace = false } = {}) => {
        if (isCalling) return;
        isCalling = true;

        let loginUrl = `//passport.${commonHost}/login?redirect_url=${encodeURIComponent(window.location.href)}`;

        const { channel, needAuth } = wechatQuickAuth();

        if (needAuth) {
            loginUrl = window.location.href = `//passport.${commonHost}/wechat-web-login?redirect_url=${encodeURIComponent(
                window.location.href,
            )}&channel=${channel}`;
        }

        if (replace) {
            window.location.replace(loginUrl);
        } else {
            window.location.href = loginUrl;
        }

        setTimeout(() => {
            isCalling = false;
        }, 300);
    };
})();
